export const contactsData = {
  email: "sagarkumarpradhan2001@gmail.com",
  phone: "+919348505856",
  address: "BTM Layout, Bengaluru, Karnataka, 560029",

  sheetAPI: "https://sheetdb.io/api/v1/ip0cwy2pkrt6y",
};
